"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class CategoryApi {
    constructor(api) {
        this.api = api;
    }
    getCategories() {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/category';
            const response = yield this.api.axiosGo.get(endpoint);
            return response.data;
        });
    }
    createCategory(category) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        return __awaiter(this, void 0, void 0, function* () {
            const data = {
                name: category.name,
                desc: (_a = category.desc) !== null && _a !== void 0 ? _a : null,
                parentId: (_b = category.parentId) !== null && _b !== void 0 ? _b : '',
                locale: (_c = this.api.locale) !== null && _c !== void 0 ? _c : 'zh',
                days: (_d = category.weekdays) !== null && _d !== void 0 ? _d : null,
                start: (_f = (_e = category.timerange) === null || _e === void 0 ? void 0 : _e[0]) !== null && _f !== void 0 ? _f : null,
                end: (_h = (_g = category.timerange) === null || _g === void 0 ? void 0 : _g[1]) !== null && _h !== void 0 ? _h : null,
                waiterOnly: (_j = category.waiterOnly) !== null && _j !== void 0 ? _j : null,
                takeawayOnly: (_k = category.takeawayOnly) !== null && _k !== void 0 ? _k : null,
                excludedDiscount: (_l = category.excludedDiscount) !== null && _l !== void 0 ? _l : false,
                excludedSurcharge: (_m = category.excludedSurcharge) !== null && _m !== void 0 ? _m : false,
                code: (_o = category.code) !== null && _o !== void 0 ? _o : null,
                isSet: false,
                type: category.type,
            };
            const response = yield this.api.axiosGo.post('/m/category', data);
            return response.data;
        });
    }
    // 更改指定語言的 name, desc
    updateCategoryTranslate(categoryId, data) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (data.locale == null) {
                data.locale = (_a = this.api.locale) !== null && _a !== void 0 ? _a : 'zh';
            }
            const endpoint = `/m/category/${categoryId}/translate`;
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    updateCategoryParent(categoryId, parentId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/category/${categoryId}/parent`;
            const response = yield this.api.axiosGo.post(endpoint, { parentId });
            return response.data;
        });
    }
    updateCategoryDays(categoryId, weekdays) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/category/${categoryId}/days`;
            const response = yield this.api.axiosGo.post(endpoint, { days: weekdays });
            return response.data;
        });
    }
    updateCategoryTime(categoryId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/category/${categoryId}/time`;
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    updateWaiterOnly(categoryId, waiterOnly) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/category/${categoryId}/waiter`;
            const response = yield this.api.axiosGo.post(endpoint, { waiterOnly });
            return response.data;
        });
    }
    updateTakeawayOnly(categoryId, takeawayOnly) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/category/${categoryId}/takeawayonly`;
            const response = yield this.api.axiosGo.post(endpoint, { takeawayOnly });
            return response.data;
        });
    }
    updateCode(categoryId, code) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/category/${categoryId}/code`;
            const response = yield this.api.axiosGo.post(endpoint, { code });
            return response.data;
        });
    }
    updateCategoryEnable(categoryId, enable) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/category/${categoryId}/enable`;
            const response = yield this.api.axiosGo.post(endpoint, { enable });
            return response.data;
        });
    }
    deleteCategory(categoryId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/category/${categoryId}`;
            const response = yield this.api.axiosGo.delete(endpoint);
            return response.data;
        });
    }
    getCategoryTag() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.get('/m/categorytag');
            return response.data;
        });
    }
    createCategoryTag(categoryTag) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/categorytag', categoryTag);
            return response.data;
        });
    }
    updateCategoryTag(categoryTag) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.put(`/m/categorytag/${categoryTag.id}`, categoryTag);
            return response.data;
        });
    }
    deleteCategoryTag(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.delete(`/m/categorytag/${id}`);
            return response.data;
        });
    }
    reorderCategoryTag(categoryTagIds) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.api.axiosGo.post('/m/merchant/sort/categorytag', { categoryTagIds });
        });
    }
}
exports.default = CategoryApi;
//# sourceMappingURL=Category.js.map